import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

const StockModal = ({ show, onHide, onSave, product, adjustment, setAdjustment }) => {
  if (!product) return null;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update Stock: {product.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Adjust Stock</Form.Label>
          <Form.Control
            type="number"
            value={adjustment}
            onChange={(e) => setAdjustment(parseInt(e.target.value))}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onSave}>
          Update Stock
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default StockModal;
